module.exports = __webpack_public_path__ + "static/media/f_hairstyle_tightcurls_short_front_vector.d69dbf28.svg";